type NotificationCounterProps = {
  max?: number;
  size?: string;
  count?: number;
  animate?: boolean;
  showPip?: boolean;
  showCount?: boolean;
};

export const NotificationCounter = (props: NotificationCounterProps) => {
  const {
    count,
    max = 9,
    animate = false,
    showPip = true,
    showCount = true,
    size = '5',
  } = props;
  return (
    <div
      className={`${showPip ? 'ui-flex' : 'ui-hidden'} ui-relative ui-w-${size} ui-h-${size} ui-items-center ui-justify-center ui-rounded-full ui-text-[11px] ui-font-semibold ui-bg-red-600 ui-text-white`}
    >
      <div className="ui-relative ui-z-10">
        {showCount && count && (max > count ? count : `${max}+`)}
      </div>

      {animate && (
        <div
          className={
            'ui-absolute ui-inset-0 ui-rounded-full ui-animate-ping ui-bg-red-600 ui-opacity-80'
          }
        />
      )}
    </div>
  );
};
